import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/help-requests/')({
  validateSearch: (search: Record<string, unknown>) => search,
});
